import { EventsAPI } from "api_inbusiness";
import { PageLayout } from "lib";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams, useHistory } from "react-router-dom";
import styles from "./Ticket.module.scss";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import QrCode from "react-qr-code";
import { LoadingSpinner } from "lib";
import { UtilityButton } from "lib/components/Buttons/buttons";
import EditTicket from "./EditTicket";
import { useUser } from "hooks/useUser";

const Ticket = () => {
  const { id } = useParams();
  const navigate = useHistory();
  const { permissionsData, loadingUser } = useUser();
  const [ticket, setTicket] = useState({});
  const [loading, setLoading] = useState(true);
  const [editTicket, setEditTicket] = useState(false);

  // Redirect unauthorized users to home only after user permissions have loaded
  useEffect(() => {
    if (
      !loadingUser &&
      !permissionsData.seeAdminButtons &&
      !permissionsData.seeVolunteerSections
    ) {
      navigate.push("/");
    }
  }, [
    permissionsData.seeAdminButtons,
    permissionsData.seeVolunteerSections,
    loadingUser,
    navigate,
  ]);

  const getTicket = () => {
    EventsAPI.getTicket(id).then((res) => {
      setTicket(res.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    getTicket();
  }, []);

  return (
    <>
      <Helmet>
        <title>InBusiness CRM :: Bilet</title>
      </Helmet>
      <PageLayout backArrow={true} title="Bilet">
        {loading ? (
          <LoadingSpinner loading={loading} margin={"0 auto"} />
        ) : (
          <div className={styles.ticketContainer}>
            <div className={styles.ticketInfoContainer}>
              <div>Nume Complet</div>
              <div>{ticket.fullName}</div>
            </div>
            <div className={styles.ticketInfoContainer}>
              <div>Eveniment</div>
              <div>{ticket.event?.title}</div>
            </div>
            <div className={styles.ticketInfoContainer}>
              <div>Seria</div>
              <div>{ticket.serial}</div>
            </div>
            <div className={styles.ticketInfoContainer}>
              <div>Numar</div>
              <div>{ticket.number}</div>
            </div>
            <div className={styles.ticketInfoContainer}>
              <div>Tip Bilet</div>
              <div style={{ fontWeight: "bold", color: ticket.isVip ? "#ca8a04" : "#475569" }}>
                {ticket.isVip ? "⭐ VIP" : "Standard"}
              </div>
            </div>
            <div className={styles.ticketInfoContainer}>
              <div>Valid</div>
              <div>
                {ticket.valid === true ? (
                  <CheckCircleIcon sx={{ color: "green" }} />
                ) : (
                  <DoDisturbIcon sx={{ color: "red" }} />
                )}
              </div>
            </div>
            {ticket?.id && (
              <div className={styles.qrContainer}>
                <div style={{ fontWeight: 600 }}>Cod QR</div>
                <div
                  style={{
                    background: "#ffffff",
                    padding: "16px",
                    borderRadius: "12px",
                    display: "inline-flex",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <QrCode size={140} value={ticket.id} viewBox={`0 0 256 256`} />
                </div>
              </div>
            )}
            {permissionsData.seeAdminButtons && (
              <div className={styles.editButtonStyle}>
                <UtilityButton onClick={() => setEditTicket(true)}>
                  Edit
                </UtilityButton>
              </div>
            )}
          </div>
        )}
        <EditTicket
          open={editTicket}
          setOpen={setEditTicket}
          ticket={ticket}
          getTicket={getTicket}
        />
      </PageLayout>
    </>
  );
};

export default Ticket;
